export default __webpack_public_path__ + "static/media/apple-icon-57x57.675cd588.png";